// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadWishList,
} from "@insite/client-framework/Store/Components/ManageShareListModal/Handlers/RemoveWishListShare";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";

// XNG-Change: remove "exclude:listlines" to fix OOTB issue mentioned in CMI-854
export const XngLoadWishList: typeof LoadWishList = props => {
    props.dispatch(
        loadWishList({
            wishListId: props.parameter.wishList.id,
            expand: ["schedule", "sharedUsers", "favorite", "hidden", "tags"],
        }),
    );
};

replaceInChain(chain, LoadWishList, XngLoadWishList);
